import React, { useEffect, useState } from "react";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { useAuth } from "../context/AuthContext";
import { getBranding } from "../api";

interface Props {
  children: React.ReactNode;
}

function RequireAuth({ children }: Props) {
  const { inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const { user, loading, error, login } = useAuth();
  const [loginLogoUrl, setLoginLogoUrl] = useState<string | null>(null);

  useEffect(() => {
    getBranding()
      .then((b) => { if (b.login_logo_url) setLoginLogoUrl(b.login_logo_url); })
      .catch(() => { /* silently use default */ });
  }, []);

  if (inProgress !== InteractionStatus.None) {
    return (
      <div style={centerStyle}>
        <p style={{ color: "#666" }}>Signing in...</p>
      </div>
    );
  }

  if (isAuthenticated && loading) {
    return (
      <div style={centerStyle}>
        <p style={{ color: "#666" }}>Loading your profile...</p>
      </div>
    );
  }

  if (!isAuthenticated || !user) {
    return (
      <div style={centerStyle}>
        <div style={cardStyle}>
          {loginLogoUrl ? (
            <img
              src={loginLogoUrl}
              alt="Logo"
              style={{ maxHeight: "80px", maxWidth: "200px", display: "block", margin: "0 auto 24px", objectFit: "contain" }}
              onError={() => setLoginLogoUrl(null)}
            />
          ) : (
            <div style={{
              width: "56px", height: "56px", borderRadius: "50%",
              backgroundColor: "#1a5276", display: "flex", alignItems: "center",
              justifyContent: "center", margin: "0 auto 24px",
            }}>
              <span style={{ color: "white", fontSize: "24px" }}>R</span>
            </div>
          )}
          <h1 style={{ fontSize: "22px", color: "#1a1a1a", margin: "0 0 8px" }}>
            RFP Pipeline
          </h1>
          <p style={{ color: "#666", fontSize: "14px", margin: "0 0 32px" }}>
            Powerlink Opportunity Review
          </p>
          {error && (
            <div style={{
              backgroundColor: "#fdecea", border: "1px solid #f5c6cb",
              borderRadius: "4px", padding: "12px", marginBottom: "20px",
              fontSize: "13px", color: "#c0392b",
            }}>
              {error}
            </div>
          )}
          <button onClick={login} style={buttonStyle}>
            Sign in with Microsoft
          </button>
          <p style={{ color: "#999", fontSize: "12px", marginTop: "16px" }}>
            Use your Powerlink Microsoft account
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}

const centerStyle: React.CSSProperties = {
  minHeight: "100vh", display: "flex", alignItems: "center",
  justifyContent: "center", backgroundColor: "#f0f2f5",
  fontFamily: "Segoe UI, sans-serif",
};

const cardStyle: React.CSSProperties = {
  backgroundColor: "white", borderRadius: "8px", padding: "48px",
  boxShadow: "0 2px 12px rgba(0,0,0,0.1)", textAlign: "center",
  maxWidth: "400px", width: "100%",
};

const buttonStyle: React.CSSProperties = {
  width: "100%", padding: "12px", backgroundColor: "#1a5276",
  color: "white", border: "none", borderRadius: "6px",
  fontSize: "15px", fontWeight: 600, cursor: "pointer",
};

export default RequireAuth;
